module.exports = __webpack_public_path__ + "img/right-arrow.d1a9556a.svg";